import { createSlice } from '@reduxjs/toolkit';
import { TextMessage } from '@reliance/types/models/TextMessage';

type TextMessageServerEvent = {
  data: TextMessageRelay;
  type: 'reliancetelephone.connect.text-message/persist' | string;
}

type TextMessageRelay = TextMessage & {
  facility: string | { name?: string },
  inmateName: string,
};

export type DashboardState = {
  recentTexts: TextMessageRelay[];
  textsCountByFacility: { [facilityName: string]: { Inbound: number, Outbound: number } };
};

const initialState: DashboardState = {
  recentTexts: [],
  textsCountByFacility: {}
};

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  extraReducers: (builder) => {
    builder
      .addMatcher(
        (action) => action.type === 'reliancetelephone.connect.text-message/persist',
        (state, action: TextMessageServerEvent) => {
          const textData = action.data;
          const facilityName =
            typeof textData.facility === 'string' ? textData.facility : (textData.facility?.name ?? 'Unknown');

          const normalized = {
            ...textData,
            facility: facilityName
          };

          state.recentTexts.unshift(normalized);

          const countsForFacility = state.textsCountByFacility[facilityName] || {
            Inbound: 0,
            Outbound: 0
          };

          // Increment the count of text messages for the facility associated with this message
          state.textsCountByFacility[facilityName] = countsForFacility;
          state.textsCountByFacility[facilityName][normalized.direction]++;

          // Only retain the most recent 100
          state.recentTexts = state.recentTexts.slice(0, 100);
        })
  },
  reducers: {},
});

export default dashboardSlice.reducer;